import _find from 'lodash/find';

import assignStudentTemplate from './../assign-student/assign-student.html';

export default class AddStudentsController {
  /** @ngInject */
  constructor(
    $log, $mdDialog, $mdToast,
    schoolClasses,
    groups,
    StudentService,
    GroupService
  ) {
    this.$log = $log;
    this.$mdDialog = $mdDialog;
    this.$mdToast = $mdToast;
    this.schoolClasses = schoolClasses;
    this.groups = groups;
    this.StudentService = StudentService;
    this.GroupService = GroupService;

    this.selectedSchoolClass = {};
    this.students = [];
    this.student = {};
    this.studentIds = [];
    this.selectedStudents = [];
  }

  loadStudents() {
    this.StudentService.getUnlistedStudents({
      data: this.selectedSchoolClass.schoolClassId
    }).then(result => {
      this.students = Object.assign([], result);
    });
  }

  selectStudents(studentIds) {
    this.studentIds = studentIds;
  }

  getStudents(studentIds) {
    const selectedStudents = [];
    if (studentIds.length > 0) {
      studentIds.forEach(id => {
        selectedStudents.push(this.getStudentById(id));
      });
    }

    return selectedStudents;
  }

  getStudentById(id) {
    return _find(this.students, item => {
      if (item.userId === id) {
        return item;
      }
    });
  }

  add(ev) {
    if (this.studentIds.length === 0) {
      this.$mdToast.show(
        this.$mdToast.simple()
          .textContent('Zaznacz uczniów do dodania')
          .position('bottom right')
          .hideDelay(3000)
      );
      return false;
    }

    this.$mdDialog.show({
      bindToController: true,
      controllerAs: 'ctrl',
      controller: 'AssignStudentController',
      locals: {groups: this.groups},
      template: assignStudentTemplate,
      disableParentScroll: true,
      clickOutsideToClose: true,
      targetEvent: ev,
      multiple: true
    }).then(result => {
      this.GroupService.addToGroup(result.groupId, this.studentIds, result.date).then(() => {
        this.$mdDialog.hide(result.groupId);
      })
        .catch(error => {
          this.$mdDialog.show(
            this.$mdDialog.studentsError({
              locals: {error}
            })
          );
        });
    });
  }

  cancel() {
    this.$mdDialog.cancel();
  }
}
